import { ChangeDetectionStrategy, Component, Input, computed, signal } from '@angular/core';
import { ContentBlock } from '../../models';
import { CookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';

@Component({
  selector: 'app-content-block-service',
  templateUrl: './content-block-service.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockServiceComponent extends ContentBlockBaseComponent {
  // intervalPaused = false;
  // currentIndex = 0;
  duration = 3000;
  active$ = signal<number>(0);
  activeIndex$ = computed(() => {
    const count = this.active$() || 0;

    if (!this.block.listItems?.length) {
      return 0;
    }

    return count % this.block.listItems?.length;
  });

  intervalId: any;

  setInView(e: boolean) {
    if (e) {
      // this.startList();
    } else {
      this.stopList();
      // this.currentIndex = 0;
      this.active$.set(0);
    }
  }

  startList() {
    // this.intervalId = setInterval(() => {
    //   // this.currentIndex++;
    //   let count = this.active$();
    //   count++;
    //   this.active$.set(count);
    // }, this.duration);
  }

  stopList() {
    clearInterval(this.intervalId);
  }

  trackByFn(index: number, block: any) {
    return block.id;
  }

  pause(i: number) {
    this.stopList();
    this.active$.set(i);
    // this.currentIndex = i;
  }

  start(i: number) {
    this.startList();
    this.active$.set(i);
    // this.currentIndex = i;
  }
}
